import React from "react";
import CpntFormSection from "../../../../../components/forms/CpntFormSection";
import CpntFormSectionContainer from "../../../../../components/forms/CpntFormSectionContainer";
import TextInput from "../../../../../components/forms/TextInput";
import SelectInput from "../../../../../components/forms/SelectInput";
import PhoneInputField from "../../../../../components/forms/PhoneInputField";
import RadioInput from "../../../../../components/forms/RadioInput";
import { civiliteList, validationMode } from "../../../../../config/helpers";

interface InscriptionFormDemandeurProps {
  fonctions: any[];
  disabled: boolean;
}

const InscriptionFormDemandeur: React.FC<InscriptionFormDemandeurProps> = ({ fonctions, disabled }) => {
  return (
    <div className="col-md-6">
      <div className="card h-100">
        <div className="card-header">
          <h6 className="mb-0 fw-bold">INFORMATIONS SUR LE DEMANDEUR (ADMINISTRATEUR DU COMPTE)</h6>
        </div>
        <div className="card-body">
          <CpntFormSection pSectionLabel="">
            <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[12]}>
              <TextInput
                label="E-mail"
                formName="Email"
                ismandatory={true}
                validationStyle={validationMode.classic}
                disabled={disabled}
              />
            </CpntFormSectionContainer>

            <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[12]}>
              <RadioInput
                label="Civilité"
                formName="IdCivilite"
                ismandatory={true}
                options={civiliteList.map((civ) => ({
                  id: civ.Id,
                  name: civ.Libelle,
                  value: civ.Id,
                }))}
                disabled={disabled}
              />
            </CpntFormSectionContainer>

            <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[6, 6]}>
              <TextInput
                label="Nom"
                formName="Nom"
                ismandatory={true}
                validationStyle={validationMode.classic}
                placeholder="Nom"
                disabled={disabled}
              />
              <TextInput
                label="Prénom"
                formName="Prenom"
                ismandatory={true}
                validationStyle={validationMode.classic}
                placeholder="Prénom"
                disabled={disabled}
              />
            </CpntFormSectionContainer>

            <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[12]}>
              <PhoneInputField
                label="Téléphone"
                formName="Telephone"
                placeholder="Numéro de téléphone"
                popover="Sélectionnez votre pays et saisissez votre numéro de téléphone."
                disabled={disabled}
              />
            </CpntFormSectionContainer>

            <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[12]}>
              <SelectInput
                label="Fonction"
                formName="IdFonction"
                ismandatory={true}
                optionEmpty="Sélectionnez une fonction"
                validationStyle={validationMode.classic}
                options={fonctions}
                disabled={disabled}
              />
            </CpntFormSectionContainer>
          </CpntFormSection>
        </div>
      </div>
    </div>
  );
};

export default InscriptionFormDemandeur;
